import { Injectable } from '@angular/core';
import { Environment } from '../../config/environment';
import { ServiceRouter } from '../core/http-service-router.service';
import { Config } from '../../config/config';
import { METHOD_TYPE } from '../../constants/service.constants';
import { NewsFeed, PECount } from '../../beans/dashboard/dashboard-module.bean';
import { forkJoin, map, Observable } from 'rxjs';
import { JwtHelper } from '../core/jwt-helper.service';

@Injectable({
	providedIn: 'root',
})
export class FeedsService {
	constructor(
		private serviceRouter: ServiceRouter,
		private environment: Environment,
		private config: Config
	) {}

	getNewsFeeds(): Observable<any> {
		const self = this;
		return self.serviceRouter.makeRequest(
			self.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			self.config.url.dashboard.getNewsFeeds,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}

	getPECount(): Observable<PECount> {
		const self = this;
		return self.serviceRouter.makeRequest(
			self.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			self.config.url.dashboard.getPECount,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}
}
